/**
* @ngdoc service
* @name common.service:MapService
* @description
* description
*/
(function() {
    'use strict';

    angular
    .module('itxApp.common')
    .service('MapService', MapService);

    MapService.$inject = [
        '$q',
    ];

    function MapService (
        $q,
    ) {
        var _this = this;

        var service =  {
            initMap:initMap
        };

        return service;

        function initMap (isBaidu) {
            var deferred = $q.defer();

            inditex.initMaps('map', inditex.iCountryCode, isBaidu ? '北京' : '', function(map) {
                
                inditex.getXconfiguracionValue('MAPS_MIN_ZOOM', function    (response, value) {
                    if (response === 1 && value) {
                        _this.minZoom = parseInt(value);
                    }
                });
                inditex.getXconfiguracionValue('MAPS_ZOOM_ICONS_CHANGE', function(response, value) {
                    if (response === 1 && value) {
                        _this.iconChangeZoom = parseInt(value);
                    }
                });
                if (!isBaidu) {
                    map.iMap.mapTypes.set('graytone',
                        new google.maps.StyledMapType(
                            [{
                                featureType: 'all',
                                elementType: 'all',
                                stylers: [{
                                    saturation: -100
                                }]
                            }], {
                                map: map.iMap,
                                name: 'graytone'
                            })
                    );
                    map.iMap.setMapTypeId('graytone');
                    map.iMap.setOptions({
                        minZoom: _this.minZoom || 2
                    });
                    if ($('html').hasClass('ie8')) {
                        map.iMap.set('mapTypeControl', false);
                    }
                    map.iMap.setZoom(_this.iconChangeZoom || 19);
                }
                deferred.resolve(map);
            });

            return deferred.promise;
        }

    }
})();
